export enum WidgetType {
	BirthDays = 2,
	Unpaid = 3,
	Sms = 4,
	FollowUp = 6,
	ValidEvent = 7,
	CurrentLicense = 8
}
